import { render, staticRenderFns } from "./BolLargeButton.vue?vue&type=template&id=5a30b04a&scoped=true"
import script from "./BolLargeButton.vue?vue&type=script&lang=js"
export * from "./BolLargeButton.vue?vue&type=script&lang=js"
import style0 from "./BolLargeButton.vue?vue&type=style&index=0&id=5a30b04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a30b04a",
  null
  
)

export default component.exports